module.exports = __webpack_public_path__ + "img/Carhouse.166238a8.png";